/**
 * Privacy Policy Page Interactive Navigation & Scrollspy
 */

document.addEventListener('DOMContentLoaded', function () {
  const contentArea = document.getElementById('policy-content-area');
  const navList = document.getElementById('policy-nav-list');
  if (!contentArea || !navList) return;

  const navElement = document.querySelector('.privacy-policy__nav');
  const mobileTrigger = document.querySelector('.privacy-policy__mobile-trigger');
  const mobileTriggerText = document.querySelector('.privacy-policy__mobile-trigger-text');

  // Find all h2 headings in content
  const headings = Array.from(contentArea.querySelectorAll('h2'));
  if (headings.length === 0) return;

  // Check if nav list is already pre-rendered
  const isNavPreRendered = navList.children.length > 0;

  // If not pre-rendered, dynamically build navigation links based on headings
  if (!isNavPreRendered) {
    headings.forEach((heading, index) => {
      // Generate clean ID from heading text if not present
      if (!heading.id) {
        heading.id = heading.textContent
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/(^-|-$)/g, '');
      }

      // Create list item and button
      const li = document.createElement('li');
      li.className = 'privacy-policy__item';

      const button = document.createElement('button');
      button.className = 'privacy-policy__button';
      button.setAttribute('data-target', heading.id);
      button.textContent = heading.textContent;

      if (index === 0) {
        button.classList.add('is-active');
        if (mobileTriggerText) {
          mobileTriggerText.textContent = heading.textContent;
        }
      }

      li.appendChild(button);
      navList.appendChild(li);
    });
  } else {
    // If pre-rendered, ensure all headings have corresponding IDs matching the buttons
    const preRenderedButtons = navList.querySelectorAll('.privacy-policy__button');
    preRenderedButtons.forEach((btn, index) => {
      if (headings[index]) {
        const targetId = btn.getAttribute('data-target') || btn.getAttribute('href')?.replace('#', '');
        if (targetId) {
          headings[index].id = targetId;
        } else {
          // If no ID exists, create one and update button
          const fallbackId = headings[index].textContent
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)/g, '');
          headings[index].id = fallbackId;
          btn.setAttribute('data-target', fallbackId);
        }
        
        if (index === 0 && mobileTriggerText) {
          mobileTriggerText.textContent = headings[index].textContent;
        }
      }
    });
  }

  // Get all navigation buttons (either newly created or pre-rendered)
  const navButtons = Array.from(navList.querySelectorAll('.privacy-policy__button'));

  // Mobile trigger toggle listener
  if (mobileTrigger && navElement) {
    mobileTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      const isOpen = navElement.classList.toggle('is-open');
      mobileTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // Setup click handler for smooth scrolling
  navButtons.forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.getAttribute('data-target') || this.getAttribute('href')?.replace('#', '');
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        // Temporarily disable scrollspy during smooth scroll execution
        isScrollSpyDisabled = true;

        // Set active class
        navButtons.forEach(btn => btn.classList.remove('is-active'));
        this.classList.add('is-active');

        // Update mobile trigger text and close dropdown
        if (mobileTriggerText) {
          mobileTriggerText.textContent = this.textContent;
        }
        if (navElement) {
          navElement.classList.remove('is-open');
          if (mobileTrigger) {
            mobileTrigger.setAttribute('aria-expanded', 'false');
          }
        }

        // Calculate position with responsive offset
        const scrollPosition = window.scrollY || window.pageYOffset;
        const elementTop = targetElement.getBoundingClientRect().top + scrollPosition;
        const offset = window.innerWidth < 990 ? 120 : 30; // Mobile topbar height vs Desktop top margin

        window.scrollTo({
          top: elementTop - offset,
          behavior: 'smooth'
        });

        // Re-enable scrollspy after smooth scroll ends
        setTimeout(() => {
          isScrollSpyDisabled = false;
        }, 800);
      }
    });
  });

  // Scrollspy logic to update active link on scroll
  let isScrollSpyDisabled = false;
  let isScrolling = false;

  function updateActiveSection() {
    if (isScrollSpyDisabled) return;

    const scrollPosition = window.scrollY || window.pageYOffset;
    const offset = window.innerWidth < 990 ? 130 : 40; // Top offset margin

    let activeId = null;

    // Trigger last heading if scrolled to the absolute bottom of the page
    if (window.innerHeight + scrollPosition >= document.documentElement.scrollHeight - 60) {
      activeId = headings[headings.length - 1].id;
    } else {
      // Find heading closest above/at the viewport offset line
      for (let i = 0; i < headings.length; i++) {
        const heading = headings[i];
        const headingTop = heading.getBoundingClientRect().top + scrollPosition;

        if (scrollPosition >= headingTop - offset - 10) {
          activeId = heading.id;
        } else {
          break; // Stop loop since headings are ordered
        }
      }
    }

    // Update buttons active class
    if (activeId) {
      navButtons.forEach(btn => {
        const target = btn.getAttribute('data-target') || btn.getAttribute('href')?.replace('#', '');
        if (target === activeId) {
          if (!btn.classList.contains('is-active')) {
            btn.classList.add('is-active');
            
            // Update mobile trigger label
            if (mobileTriggerText) {
              mobileTriggerText.textContent = btn.textContent;
            }
          }
        } else {
          btn.classList.remove('is-active');
        }
      });
    }
  }

  // Handle scroll event with requestAnimationFrame throttling
  window.addEventListener('scroll', function () {
    if (!isScrolling) {
      window.requestAnimationFrame(function () {
        updateActiveSection();
        isScrolling = false;
      });
      isScrolling = true;
    }
  });

  // Close mobile dropdown when clicking outside
  document.addEventListener('click', function (e) {
    if (navElement && navElement.classList.contains('is-open')) {
      if (!navElement.contains(e.target)) {
        navElement.classList.remove('is-open');
        if (mobileTrigger) {
          mobileTrigger.setAttribute('aria-expanded', 'false');
        }
      }
    }
  });

  // Close mobile dropdown if user scrolls the page significantly
  let lastScrollTop = 0;
  window.addEventListener('scroll', function () {
    if (navElement && navElement.classList.contains('is-open')) {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      if (Math.abs(st - lastScrollTop) > 30) {
        navElement.classList.remove('is-open');
        if (mobileTrigger) {
          mobileTrigger.setAttribute('aria-expanded', 'false');
        }
      }
      lastScrollTop = st <= 0 ? 0 : st;
    }
  }, { passive: true });

  // Run once initially to set the correct active section based on starting scroll position
  updateActiveSection();
});

// Remove standard shopify policy container wrapper if present
document.addEventListener("DOMContentLoaded", function () {
  const policyContainer = document.querySelector(".shopify-policy__container");
  if (policyContainer) {
    policyContainer.remove();
  }
});